import React, { Fragment } from 'react'
import moment from 'moment'
import useTranslation from '../../../Hooks/UseTranslation'

type Props = {
    isNotRead: boolean,
    icon: any,
    data: any,
    onClick: any,
    timeDifference: string
}

const PpcSemanalNotification = (props: Props) => {

    const { t, language } = useTranslation()

    return (
        <div className={`${props.isNotRead ? 'dropdownnotification' : ''} dropdown-item d-flex`}
            onClick={props.onClick}
        >
            <div className="notification-icon" style={{ padding: '10px' }}>
                {props.icon}
            </div>
            <div className="notification-details flex-grow-1">
                <p className="m-0 d-flex align-items-center">
                    <span>{props.data.title}</span>
                    <span
                        className={`badge badge-pill badge-muted ml-1 mr-1`}
                    >
                        {props.data.status === 'read' ? null : (
                            <span className="badge badge-pill badge-primary ml-1 mr-1">
                                {t('NOTIFICATIONS_WEEEKLY_PPC:Pending')}
                            </span>
                        )}
                    </span>
                    <span className="flex-grow-1"></span>
                    <span className=" text-muted ml-auto">
                        {language === 'es' && (
                            <Fragment>
                                {t('NOTIFICATIONS_WEEEKLY_PPC:Ago')}{' '}
                                {props.timeDifference}
                            </Fragment>
                        )}
                        {language === 'en' && (
                            <Fragment>
                                {props.timeDifference}{' '}
                                {t('NOTIFICATIONS_WEEEKLY_PPC:Ago')}
                            </Fragment>
                        )}
                    </span>
                </p>
                <p className=" text-muted m-0">
                    <span className='notification-content'>
                        {t('NOTIFICATIONS_WEEEKLY_PPC:ThePercentageOfPlanCompleted')}{' '}
                        <strong>(PPC)</strong>{' '}
                        {t('NOTIFICATIONS_WEEEKLY_PPC:OfTheProject')}{' '}
                        <strong>{props.data.project.shortName}</strong>{' '}
                        {t('NOTIFICATIONS_WEEEKLY_PPC:OfTheWeek')}{' '}
                        {props.data.projectWeek}{' '}
                        {t('NOTIFICATIONS_WEEEKLY_PPC:From')}{' '}
                        {moment().week(props.data.week).startOf('week').format('DD/MM/YYYY')}{' '}
                        {t('NOTIFICATIONS_WEEEKLY_PPC:To')}{' '}
                        {moment().week(props.data.week).endOf('week').format('DD/MM/YYYY')}{' '}
                        {t('NOTIFICATIONS_WEEEKLY_PPC:Is')}{' '}
                        {props.data.ppcPercent}%
                    </span>
                </p>
            </div>
        </div>
    )
}

export default PpcSemanalNotification